import type { ReactNode } from 'react';
import './EstadoVazio.css';

type Props = {
  readonly icone: ReactNode;
  readonly titulo: string;
  readonly detalhe: string;
  readonly tom?: 'sucesso' | 'neutro';
};

/** Vazio positivo: diz o que está em ordem, não deixa uma área em branco. */
export function EstadoVazio({ icone, titulo, detalhe, tom = 'sucesso' }: Props) {
  return (
    <div className="estado-vazio">
      <span className={`estado-vazio__icone estado-vazio__icone--${tom}`}>{icone}</span>
      <p className="estado-vazio__titulo">{titulo}</p>
      <p className="estado-vazio__detalhe">{detalhe}</p>
    </div>
  );
}
